import React, { useEffect, useState } from 'react';
import { Row, Col, Card, Table, Button, Spinner, Modal, Dropdown } from 'react-bootstrap';
import classNames from 'classnames';
import Flex from '../../common/Flex';
import Avatar from '../../common/Avatar';
import { list, remove } from '../../../lib/api/player';
import { Add } from './Add';
import { Edit } from './Edit';
import CardDropdown from 'components/common/CardDropdown';
import { format, parseISO } from 'date-fns';
import { List as EditContact } from '../contact/Lista';
import PaginationEllipsis from 'components/common/PaginationEllipsis';
import SearchPlayerAccordion from '../../common/SearchPlayerAccordion';
import { _export } from '../../../lib/api/api';
import { DocumentHistory } from './DocumentHistory';

export const List = () => {
  const [search, setSearch] = useState({});
  const [items, setItems] = useState([]);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);
  const [totalPages, setTotalPages] = useState(0);
  const [loading, setLoading] = useState(false);
  const [addPlayer, setAddPlayer] = useState(null);
  const [editPlayerId, setEditPlayerId] = useState(null);
  const [mode, setMode] = useState(null);
  const [showContactModal, setShowContactModal] = useState(false);
  const [selectedPlayer, setSelectedPlayer] = useState([]);
  const [documentHistoryPlayer, setDocumentHistoryPlayer] = useState(null);

  const user = JSON.parse(localStorage.getItem('user'));

  useEffect(() => {
    setPageSize(10);
    fetchData();
  }, [page, pageSize, search]);

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await list({ ...{ page, pageSize }, ...search });
      setItems(response.data);
      setTotalPages(response.totalPages);
    } catch (error) {
      console.error('Greska prilikom ucitavanja podataka:', error);
    }
    setLoading(false);
  };

  const handlePageChange = newPage => {
    if (newPage > 0 && newPage <= totalPages) {
      setPage(newPage);
    }
  };

  const handleAddPlayer = newPlayer => {
    setItems(prev => [newPlayer, ...prev]);
  };

  const handleUpdatePlayer = updatedPlayer => {
    setItems(prev =>
      prev.map(p => (p.document_guid === updatedPlayer.document_guid ? updatedPlayer : p))
    );
  };

  const handelDelete = async (id, name) => {
    if (confirm(`Da li ste sigurni da zelite da izbrisete igraca ${name}?`)) {
      await remove(id);
      setItems(prev => prev.filter(p => p.document_guid !== id));
    }
  };

  const handleContact = id => {
    const item = items.find(c => c.document_guid === id);
    setSelectedPlayer(item);
    setShowContactModal(true);
  };

  const getPlayerName = item => `${item.name} ${item.last_name}`;

  const getGenderLabel = item => (item.gender_type_id === 1 ? 'Muski' : 'Zenski');

  const getBirthDateLabel = item =>
    format(
      typeof item.date_of_birth === 'string' ? parseISO(item.date_of_birth.slice(0, 10)) : item.date_of_birth,
      'dd.MM.yyyy'
    );

  const getClubNameLabel = item => item.club_name || item.name_club || item.short_name || '-';

  const renderActions = item => (
    <CardDropdown>
      <div className="py-2">
        <Dropdown.Item
          onClick={() => {
            setEditPlayerId(item.document_guid);
            setMode('view');
          }}
        >
          Pregled podataka
        </Dropdown.Item>
        <Dropdown.Divider />
        <Dropdown.Item onClick={() => setDocumentHistoryPlayer(item)}>
          Istorijat dokumenata
        </Dropdown.Item>
        <Dropdown.Divider />
        <Dropdown.Item onClick={() => handleContact(item.document_guid)}>Kontakti</Dropdown.Item>
        <Dropdown.Item
          onClick={() => {
            setEditPlayerId(item.document_guid);
            setMode('edit');
          }}
        >
          Edit
        </Dropdown.Item>
        {!user.club_guid ? (
          <Dropdown.Item
            className="text-danger"
            onClick={() => handelDelete(item.document_guid, getPlayerName(item))}
          >
            Delete
          </Dropdown.Item>
        ) : (
          ''
        )}
      </div>
    </CardDropdown>
  );

  const openPlayerPreview = item => {
    setEditPlayerId(item.document_guid);
    setMode('view');
  };

  return (
    <>
      <Row className="g-3">
        <SearchPlayerAccordion
          handleSearch={data => {
            setSearch(data);
          }}
          handleExport={data => {
            setSearch(data);
            _export({ target: 'player/export', method: 'GET', params: data }).then(() => {
              console.log('Ok');
            });
          }}
        />
        <Col xs={12}>
          <Card className={classNames('h-100')}>
            <Card.Header>
              <Row className={classNames('g-2')}>
                <Col>
                  <Flex>
                    <h5 className="mb-0 hover-actions-trigger text-truncate text-nowrap">
                      Spisak igraca
                    </h5>
                  </Flex>
                </Col>
                <Col xs="auto">
                  <Button onClick={() => setAddPlayer(true)} variant="primary">
                    Dodaj igraca
                  </Button>
                </Col>
              </Row>
            </Card.Header>

            <Card.Body className="bg-body-tertiary">
              {loading ? (
                <div className="text-center">
                  <Spinner animation="border" role="status" />
                </div>
              ) : (
                <Row className="mb-3">
                  <div className="d-none d-xl-block">
                    <Table responsive className="mb-0 align-middle">
                      <thead>
                        <tr>
                          <th>Ime i prezime</th>
                          <th>Pol</th>
                          <th>Licenca</th>
                          <th>Datum rodjenja</th>
                          <th>Mjesto rodjenja</th>
                          <th>Klub</th>
                          <th></th>
                          <th className="text-end">Akcije</th>
                        </tr>
                      </thead>
                      <tbody>
                        {items.map(item => (
                          <tr key={item.document_guid}>
                            <td>
                              <div className="d-flex align-items-center">
                                <Avatar
                                  src={`${process.env.REACT_APP_BASE_API_URL}/uploads/${item.image_path}`}
                                  size="2xl"
                                  name={item.name}
                                />
                                <div className="ms-2">{getPlayerName(item)}</div>
                              </div>
                            </td>
                            <td>{getGenderLabel(item)}</td>
                            <td>
                              <div className="ms-2">{item.player_id}</div>
                            </td>
                            <td>
                              <div className="ms-2">{getBirthDateLabel(item)}</div>
                            </td>
                            <td>
                              <div className="ms-2">{item.place}</div>
                            </td>
                            <td>
                              <div className="ms-2">
                                {item.club_entities_guide && (
                                  <Avatar
                                    src={`${process.env.REACT_APP_BASE_API_URL}/uploads/${item.club_image_path}`}
                                    size="l"
                                    name={item.short_name}
                                  />
                                )}
                              </div>
                            </td>
                            <td>
                              <div className="ms-2">
                                <small>{item.short_name}</small>
                              </div>
                            </td>
                            <td className="text-end">{renderActions(item)}</td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>

                  <div className="d-xl-none">
                    <Row className="g-3">
                      {items.map(item => (
                        <Col xs={12} key={item.document_guid}>
                          <div
                            className="border rounded-4 bg-white h-100 p-3 shadow-sm cursor-pointer"
                            style={{ borderColor: '#dfe3ee' }}
                            onClick={() => openPlayerPreview(item)}
                          >
                            <div className="d-flex align-items-start justify-content-between gap-3">
                              <div className="flex-shrink-0">
                                <Avatar
                                  src={`${process.env.REACT_APP_BASE_API_URL}/uploads/${item.image_path}`}
                                  size="2xl"
                                  name={item.name}
                                />
                              </div>
                              <div
                                className="flex-shrink-0"
                                onClick={event => event.stopPropagation()}
                              >
                                {renderActions(item)}
                              </div>
                            </div>

                            <div className="mt-3">
                              <div className="fw-semibold text-dark fs-8">{getPlayerName(item)}</div>

                              <div className="d-flex flex-wrap gap-2 mt-2">
                                <span className="badge rounded-pill badge-subtle-success">
                                  {getGenderLabel(item)}
                                </span>
                                <span className="badge rounded-pill badge-subtle-primary">
                                  {item.player_id}
                                </span>
                              </div>

                              <div className="text-600 fs-10 mt-2">
                                {getBirthDateLabel(item)}
                                {item.place ? ` - ${item.place}` : ''}
                              </div>

                              <div className="text-700 fs-10 mt-1">{getClubNameLabel(item)}</div>
                            </div>
                          </div>
                        </Col>
                      ))}
                    </Row>
                  </div>
                </Row>
              )}
            </Card.Body>
            <Card.Footer>
              <Row className="justify-content-center">
                <PaginationEllipsis
                  page={page}
                  totalPages={totalPages}
                  onPageChange={handlePageChange}
                />
              </Row>
            </Card.Footer>

            {addPlayer && (
              <Modal show onHide={() => setAddPlayer(false)} size="lg">
                <Modal.Body>
                  <Add
                    onClose={() => {
                      setAddPlayer(null);
                    }}
                    onAdd={handleAddPlayer}
                  />
                </Modal.Body>
              </Modal>
            )}

            {editPlayerId && (
              <Modal show onHide={() => setEditPlayerId(null)} size="lg">
                <Modal.Body>
                  <Edit
                    playerId={editPlayerId}
                    initMode={mode}
                    onClose={() => {
                      setEditPlayerId(null);
                    }}
                    onUpdate={handleUpdatePlayer}
                  />
                </Modal.Body>
              </Modal>
            )}

            <Modal show={showContactModal} onHide={() => setShowContactModal(false)} size="lg">
              <Modal.Header closeButton>
                <Modal.Title>Kontakt</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <EditContact
                  initPartner={selectedPlayer}
                  onClose={() => setShowContactModal(false)}
                />
              </Modal.Body>
            </Modal>

            <DocumentHistory
              player={documentHistoryPlayer}
              onClose={() => setDocumentHistoryPlayer(null)}
            />
          </Card>
        </Col>
      </Row>
    </>
  );
};
